import { shaderMaterial } from '../core/shaderMaterial.js';

const DiscardMaterial = shaderMaterial({}, 'void main() { }', 'void main() { discard; }');

export { DiscardMaterial };
